// Docs: https://github.com/WorkpathHQ/workpath_web/wiki/Container-Constants-Docs
export const GET_GOAL_PROGRESS_OVER_TIME_REQUEST =
  'app/GoalProgressOverTimeModal/GET_GOAL_PROGRESS_OVER_TIME_REQUEST';
export const GET_GOAL_PROGRESS_OVER_TIME_SUCCESS =
  'app/GoalProgressOverTimeModal/GET_GOAL_PROGRESS_OVER_TIME_SUCCESS';
export const GET_GOAL_PROGRESS_OVER_TIME_ERROR =
  'app/GoalProgressOverTimeModal/GET_GOAL_PROGRESS_OVER_TIME_ERROR';
